import androidx.compose.runtime.*
import frontend.App
import frontend.pages.SignInUI
import frontend.pages.SignUpUI

@Composable
fun AuthorizationUI(app: App) {
    var isLogin: Boolean by remember { mutableStateOf(true) }


    fun toggleScreen() {
        isLogin = !isLogin
    }

    if (isLogin) SignInUI(app) { toggleScreen() }
    else SignUpUI { toggleScreen() }

}